import { Incident } from "../model/incident";
import { GunshotObservation } from "../model/rounds";
import { tutToDate } from "../util";

// Colons are not allowed in filenames on all platforms, so the ISO time is dashed
export const createAudioDownloadName = (incident: Incident) => {
  const isoDate = tutToDate(incident.tut).toISOString().replace(/:/g, "-");
  return `${incident.deviceId}_${isoDate}.wav`;
};

export const createUrl = (objectPath: string, bucket: string) => {
  return `https://api.triangula.com/backoffice/audio/storage?url=${objectPath}&bucket=${bucket}`;
};

export const createUrlForShot = (
  observation: GunshotObservation,
  db: number,
  noiseReduction: boolean,
  pre?: number,
  post?: number
) => {
  return `https://api.triangula.com/backoffice/audio/gunshot?roundName=${
    observation.round.name
  }&deviceId=${observation.device.name}&shotNumber=${observation.shot.index}&audioTut=${
    observation.audio.tut
  }&db=${db}&noiseReduction=${noiseReduction}${pre ? `&pre=${pre}` : ""}${
    pre ? `&post=${post}` : ""
  }`;
};

export const createUrlForKrazyGale = (
  observation: GunshotObservation,
  db: number,
  pre: number,
  post: number,
  gunshotThreshold: number,
  windowLength: number,
) => {
  return `https://api.triangula.com/classifiers/gunshot/krazyGale?roundName=${
    observation.round.name
  }&deviceId=${observation.device.name}&audioTut=${
    observation.audio.tut
  }&pre=${pre}&post=${post}&gunshotThreshold=${gunshotThreshold}&windowLength=${windowLength}`;
};

export const createImageUrl = (
  observation: GunshotObservation,
  pre?: number,
  post?: number
) => {
  return `https://api.triangula.com/backoffice/audio/gunshot/image?roundName=${
    observation.round.name
  }&deviceId=${observation.device.name}&shotNumber=${observation.shot.index}${
    pre ? `&pre=${pre}` : ""
  }${pre ? `&post=${post}` : ""}`.replace("+", "%2B");
};

export const createComparisonUrl = (
  observation: GunshotObservation,
) => {
  return `https://api.triangula.com/round/shiftComparison/${observation.round.name}/${observation.device.name}/${observation.shot.index}`
  .replace("+", "%2B");
};
